import { LocalBrick } from './LocalBrick'
import { isSet } from '../../util/functions'
import { ReactNode } from 'react'
import { Licenses } from '../scenarios/data'

export type ApplicationLicense = 'nu'|'su'|'uu'|'csclient'|'cmclient'|'tsclient'|'ic'|'wlssu'|'wlsuu'

export abstract class ApplicationBrick extends LocalBrick {
    private container: boolean
    private orchestrated: boolean

    constructor(license: ApplicationLicense, readonly api: string, readonly framework: string, readonly packageManager: string, container: boolean, orchestrated: boolean) {
        super(license)
        this.container = container
        this.orchestrated = orchestrated
    }

    public isContainer(): boolean {
        return this.container
    }

    public isOrchestrated(): boolean {
        return this.orchestrated
    }

    get icon(): string | null {
        return this.license!=null && (['su', 'uu', 'nu', 'wlssu', 'wlsuu', 'fu'].includes(this.license)) ? 'solver' : null;
    }

    get title(): string {
        return 'Application'
    }

    get sortIndex(): number {
        return 5
    }

    packageManagerContainsLicenseTools(): boolean {
        return false
    }

    frameworkRequiresFullInstallation(): boolean {
        return false
    }

    installWithoutPackageManagerRequiresFullInstallation(): boolean {
        return true
    }

    requiresFullInstallation(): boolean {
        return ((this.packageManager == '' && this.framework == '' && this.installWithoutPackageManagerRequiresFullInstallation()) || this.frameworkRequiresFullInstallation()) && !this.isContainer()
    }

    requireLicenseTools(): boolean {
        return !this.requiresFullInstallation() && this.isLocalLicense() && !this.packageManagerContainsLicenseTools()
    }

    requireLicenseFile(): boolean {
        return this.isLocalLicense() || isSet(this.framework)
    }

    public describe(): ReactNode
    {
        if(this.license == null ) {
            throw Error("Unknown license")
        }
        const license = this.license in Licenses ? Licenses[this.license!].name : this.license
        // TODO (3) Cleaner formatting (4) Add tsclient license, also in constructor!?
        const machineLicense = <>It has a <b>{license}</b> license. Models are being defined and solved locally, in the same process.</>
        const wlsLicense = <>It requests a <b>token</b> from the Web License Service.</>
        const remote = (name: string, prefix: string, preposition: string) => <>It has <b>{preposition} {name} client license</b>. When a model needs to be solved, Gurobi takes care of handing over the model to {prefix} {name}.</>
        const licenseSources : Record<string, ReactNode> = {
            'nu': machineLicense,
            'su': machineLicense,
            'uu': machineLicense,
            'csclient': remote('Compute Server', 'your', 'a'),
            'cmclient': remote('Cluster Manager', 'your', 'a'),
            'ic': remote('Instant Cloud', 'our', 'an'),
            'wlssu': wlsLicense,
            'wlsuu': wlsLicense,
            'tsclient': <>It requests a <b>token</b> from the Token Server.</>
        }
        const location: ReactNode = this.container ? <>It runs inside a container.</> : <>It runs on a (virtual) machine.</>
        return <p>Your <b>application</b> is written in {this.api}{this.framework && <> using {this.framework}</>}{this.packageManager && <> using {this.packageManager}.</>} {location} {licenseSources[this.license!]}</p>        
    }
}
